import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const REEL_CREATOR_FILTER_PREFIX = "reel_creator/filter_list";
export const filterReelCreatorListFormTypes = createFormActionTypes(REEL_CREATOR_FILTER_PREFIX);
export const filterReelsCreatorListFormActions = createFormActions(filterReelCreatorListFormTypes);
